import React, { useMemo, useState } from "react";
import dayjs from "dayjs";
import DateBox from "./DateBox";

function Calendar ({ events = [] }) {

  const [currentDate, setCurrentDate] = useState(dayjs());
  const [selectedDate, setSelectedDate] = useState(null);
  const today = dayjs();

  // Navigation handlers
  const prevMonth = () => setCurrentDate((d) => d.subtract(1, "month"));
  const nextMonth = () => setCurrentDate((d) => d.add(1, "month"));

  // Generate month grid: fill to full weeks (35 or 42 cells)
  const generateMonthGrid = () => {
    const startOfMonth = currentDate.startOf("month");
    const endOfMonth = currentDate.endOf("month");
    const startDayOfWeek = startOfMonth.day();
    const daysInMonth = endOfMonth.date();

    const daysArray = [];

    // Leading days from previous month
    for (let i = 0; i < startDayOfWeek; i++) {
      daysArray.push({
        date: startOfMonth.subtract(startDayOfWeek - i, "day"),
        inCurrentMonth: false
      });
    }

    // Current month days
    for (let i = 1; i <= daysInMonth; i++) {
      daysArray.push({ date: startOfMonth.date(i), inCurrentMonth: true });
    }

    // Tail days to complete the grid
    const total = daysArray.length;
    const gridCells = Math.ceil(total / 7) * 7; // 35 or 42 typically
    const remainingCells = gridCells - total;
    for (let i = 1; i <= remainingCells; i++) {
      daysArray.push({ date: endOfMonth.add(i, "day"), inCurrentMonth: false });
    }

    return daysArray;
  };

  const daysInGrid = generateMonthGrid();

  // Handle day selection
  const handleDayClick = (date) => {
    setSelectedDate(date);
  };

  const groupedEvents = useMemo(() => {
    const grouped = {};
    for (const event of events) {
      const dateKey = dayjs(event.startDatetime).format("YYYY-MM-DD");
      if (!grouped[dateKey]) grouped[dateKey] = [];
      grouped[dateKey].push(event);
    }
    return grouped;
  }, [events]);

  return (
      <div>
          <div className="max-w-sm mx-auto px-6 py-4 bg-pink-100 rounded-xl shadow-lg border-5 border-pink-500">




          {/* Calendar Header */}
          <h2 className="text-4xl font-bold text-center mb-4 ">
            Party Calendar
          </h2>
  
          <header className="flex items-center justify-between mb-6">
            <button onClick={prevMonth} 
                    className={"!outline-none !focus-visible:hidden"}>«</button>
  
            <div className="text-center">
              <h4 className="text-3xl font-bold">{currentDate.format("MMM")}</h4>
              <h5 className="text-xl text-gray-500">{currentDate.format("YYYY")}</h5>
            </div>
  
            <button onClick={nextMonth}
                    className={"!outline-none !focus-visible:hidden"}>»</button>
          </header>
  
          {/* Weekdays Header */}
          <div className="font-bold grid grid-cols-7 gap-y-2 gap-x-1 
          mb-4 text-center text-gray-600 text-sm">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                <span key={day}>{day}</span>
            ))}

            {/* Calendar Days */}
            {daysInGrid.map((dayObj, index) => (
                <DateBox
                    key={index}
                    dayObj={dayObj}
                    today={today}
                    onClick={handleDayClick}
                    events={groupedEvents[dayObj.date.format("YYYY-MM-DD")] || []}
                />
            ))}
          </div>
        </div>
      </div>
  );
}

export default Calendar;
